import { pngApproachesToValueChartMaker } from '../../../components/graphs/reconciliation/pngApproachesToValueChartMaker.tsx';
import { pngHomeValueIndexTrendsChartMakerV2 } from '../../summaryV2/utils/pngHomeValueIndexTrendsChartMaker.tsx';
import { pngSiteSizeToCostPerSFChartMaker } from '../../summaryV2/utils/pngSiteSizeToCostPerSFChartMaker.tsx';
import { pngSiteSizeToSiteValueChartMaker } from '../../summaryV2/utils/pngSiteSizeToSiteValueChartMaker.tsx';
import { Tkv2PDF, Tkv2PDFChartImages } from '../types.ts';
import { generateMarketConditionGraphImages } from './marketConditionGraphImages.tsx';

export const generateTkv2PDFChartImages = async (
  chartParams: Tkv2PDF['chartParams'],
  includeCostApproach: boolean,
  marketAggregateData?: Tkv2PDF['marketAggregateData'],
): Promise<Tkv2PDFChartImages> => {
  const dateOfSaleChartImage = await pngHomeValueIndexTrendsChartMakerV2(chartParams.dateOfSale);
  const siteSizeVsSiteValueChartImage = await pngSiteSizeToSiteValueChartMaker(chartParams.site);
  const siteSizeVsCostChartImage = await pngSiteSizeToCostPerSFChartMaker(chartParams.site);
  const aivApproachesToValueChartImage = await pngApproachesToValueChartMaker({
    reconciliationData: chartParams.aivReconciliationData,
    includeCostApproach,
  });
  let arvApproachesToValueChartImage: string | undefined;
  if (chartParams.arvReconciliationData) {
    arvApproachesToValueChartImage = await pngApproachesToValueChartMaker({
      reconciliationData: chartParams.arvReconciliationData,
      includeCostApproach,
    });
  }
  const marketConditionGraphImages = await generateMarketConditionGraphImages(marketAggregateData);

  return {
    dateOfSaleChartImage,
    siteSizeVsSiteValueChartImage,
    siteSizeVsCostChartImage,
    aivApproachesToValueChartImage,
    arvApproachesToValueChartImage,
    marketConditionGraphImages,
  };
};
